import { z } from 'zod';

/**
 * `pending-flake-detective` v0 — wire types for the LLM-authored
 * single-hypothesis-per-run flake diagnosis.
 *
 * Locked decisions (2026-05-28):
 *   - 6 categories, no runtime expansion.
 *   - Confidence is LLM-self-reported, surfaced verbatim.
 *   - Single hypothesis per run (top-1 confidence); v1 may surface
 *     a second-rank for triage.
 */

export const FLAKE_CATEGORIES = [
  'race',
  'animation',
  'network-timeout',
  'stale-element',
  'state-leak',
  'other',
] as const;
export type FlakeCategory = (typeof FLAKE_CATEGORIES)[number];

export const FlakeHypothesisSchema = z.object({
  runId: z.string(),
  flowId: z.string(),
  orgId: z.string(),
  stepIndex: z.number().int().nonnegative(),
  hypothesisText: z.string(),
  hypothesisCategory: z.enum(FLAKE_CATEGORIES),
  confidence: z.number().min(0).max(1),
  llmProvider: z.string().nullable(),
  createdAt: z.string(),
});
export type FlakeHypothesis = z.infer<typeof FlakeHypothesisSchema>;

export const FlakeHypothesisResponseSchema = FlakeHypothesisSchema;
export type FlakeHypothesisResponse = z.infer<typeof FlakeHypothesisResponseSchema>;
